/**
 * English: Toast notification wrapper with Coinbase styling.
 * Thai: Toast notification wrapper with Coinbase styling
 */
import { Toaster } from 'react-hot-toast';
export { toast } from 'react-hot-toast';

export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 3500,
        style: {
          background: 'var(--color-surface-card)',
          color: 'var(--color-ink)',
          border: '1px solid var(--color-hairline)',
          fontSize: '0.875rem',
          borderRadius: '0.75rem',
          padding: '0.75rem 1rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        },
        success: {
          iconTheme: { primary: 'var(--color-semantic-up)', secondary: 'white' },
        },
        error: {
          iconTheme: { primary: 'var(--color-semantic-down)', secondary: 'white' },
          duration: 5000,
        },
      }}
    />
  );
}